export default __webpack_public_path__ + "static/media/king.59729d7c.jpg";